export default __webpack_public_path__ + "static/media/photo--lg--alaina-3.3a9d2783.jpg";